import './Rental.css'

// Embeds the rentalui homepage microfrontend (jewelry/car rental/real estate/hospitality
// verticals) at /rental. Kept as a single iframe embed so campui only needs one new route - see
// rentalui/homepage for the embedded app. Production points at the rentals.tornacampsites.com
// subdomain (baked in at Docker build time, see Dockerfile/cloudbuild.yaml).
const RENTAL_URL = process.env.REACT_APP_RENTAL_URL || 'http://localhost:5175'

export default function Rental() {
    return (
        <div className="rentalContainer">
            <iframe
                title="Rental"
                src={RENTAL_URL}
                className="rentalFrame"
            />
        </div>
    );
}
